import React from 'react';
import ListingImageGallery from './ListingImageGallery/ListingImageGallery';

import css from './ListingPage.module.css';
import Icons from '../../components/Icons/Icons';
import { ensureListing } from '../../util/data';
import useWishlist from '../../hooks/useWishlist';
import { IconSpinner } from '../../components';

const SectionGallery = props => {
  const { listing, variantPrefix, viewport } = props;
  const currentListing = ensureListing(listing);

  const images = currentListing.images;
  const imageVariants = ['scaled-small', 'scaled-medium', 'scaled-large', 'scaled-xlarge'];
  const thumbnailVariants = [variantPrefix, `${variantPrefix}-2x`, `${variantPrefix}-4x`];

  const isTabLayout = viewport?.width && viewport?.width > 0 && viewport?.width < 1024;

  const { isProcessing, toggleWishlist, iconName, isOwnListing } = useWishlist(currentListing);

  return (
    <section className={css.productGallery} data-testid="carousel">
      <ListingImageGallery
        images={images}
        imageVariants={imageVariants}
        thumbnailVariants={thumbnailVariants}
        viewport={viewport}
      />

      {isTabLayout && !isOwnListing && (
        <div className={css.productActions}>
          <button
            type="button"
            className={css.favorite}
            onClick={toggleWishlist}
            aria-label="Toggle favorite"
          >
            <div className={css.icon}>
              {isProcessing ? <IconSpinner /> : <Icons name={iconName} />}
            </div>
          </button>
        </div>
      )}
    </section>
  );
};

export default SectionGallery;
